import { ContentChild, Directive, ElementRef, HostListener, OnInit, Renderer2 } from '@angular/core';
import { ComponentBase } from 't4core';

@Directive({ selector: '[t4-tooltip]'})
export class T4Tooltip extends ComponentBase implements OnInit {
    private _content: ElementRef;
    @ContentChild('tooltipContent', {static: true})
    set tooltipContent(value: ElementRef) {
        if (this._content != value) {
            this._content = value;
        }
    };

    private _hiding: boolean = false;
    private _opening: boolean = false;
    private _open: boolean = false;


    constructor(private el: ElementRef, private renderer:Renderer2) {
        super();
    }

    ngOnInit(): void {
        this.renderer.listen(this._content.nativeElement, "mouseenter", (e) => {
            this._hiding = false;
        });

        this.renderer.listen(this._content.nativeElement, "mouseleave", (e) => {
            this._hiding = true;
            setTimeout(() => {
                if (this._hiding) this.hide();
            }, 100);
        });
    }

    @HostListener('mouseenter', ['$event']) onMouseEnter(e) {
        this._opening = true;
        this._hiding = false;
        setTimeout(() => {
            if(this._opening) this.show(e.pageX - e.offsetX + e.target.clientWidth, e.pageY - e.offsetY + e.target.clientHeight, e.target.clientWidth, e.target.clientHeight);
        }, 500);
    }

    
    @HostListener('mouseleave', ['$event']) onMouseLeave(e) {
        this._hiding = true;
        this._opening = false;
        setTimeout(() => {
            if (this._hiding) this.hide();
        }, 100);
    }

    @HostListener('click', ['$event']) onClick(e) {
        e.stopPropagation();
    }

    private show(x: number, y: number, thisWidth: number, thisHeight: number) {
        if (this._open) return;
        this._open = true;

        this.UI.float(this._content.nativeElement, x, y, null, null, thisWidth, thisHeight);
    }

    private hide() {
        if (!this._open) return;

        this._open = false;
        this.UI.drop(this._content.nativeElement);
    }
}
